import React from "react";
import { useTranslation } from "react-i18next";

import ReceiptClockIcon from "pages/assets/icons/ReceiptClockIcon";

function PendingPayment({ timer, handleCheckPayment, order }) {
  const { t } = useTranslation();

  return (
    <section>
      <div className="space-y-8 app-main-container">
        <div className="flex flex-col items-center pt-20 space-y-4">
          <ReceiptClockIcon />
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-2">
            {t("pendingPaymentHeading")}
          </p>
        </div>
        <div className="flex flex-col items-center p-4 bg-app-blue-light rounded-xl">
          <span className="text-sm font-bold sm:text-base">
            {t("paymentExpiredDateHeading")}:
          </span>
          <p>
            <span className="font-bold">{timer?.hours}</span> {t("hour")} :{" "}
            <span className="font-bold">{timer?.minutes}</span> {t("minute")} :{" "}
            <span className="font-bold">{timer?.seconds}</span> {t("second")}
          </p>
        </div>
        <p className="text-xs text-center sm:text-sm sm:mx-16">
          {t("pendingPaymentDisclaimer")}
        </p>

        <div className="flex flex-col items-center w-full space-y-2">
          <button
            onClick={handleCheckPayment}
            className={`
              bg-app-blue
              px-5
              py-2 
              text-white 
              rounded-md 
              text-sm 
              md:text-base
            `}
            disabled={!order?.mpayment_link}
          >
            {t("checkPaymentButton")}
          </button>
        </div>
      </div>
    </section>
  );
}

export default PendingPayment;
